import { render, staticRenderFns } from "./SocialPostingStatus.vue?vue&type=template&id=6a7917b0"
import script from "./SocialPostingStatus.vue?vue&type=script&lang=ts"
export * from "./SocialPostingStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports